import { cardItems } from '@/mocks/comics';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-10 flex-wrap gap-3">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">精选推荐</h2>
              <p className="text-sm text-foreground-500">编辑精心挑选的高分漫画作品</p>
            </div>
            <a
              href="#index"
              className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部类型 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.slice(0, 5).map((item, i) => (
              <div
                key={i}
                className={`bg-background-100 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer ${
                  i === 0 ? 'lg:col-span-2' : ''
                }`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${
                      i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'
                    }`}
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <span className="text-xs text-accent-600 font-medium">{item.subtitle}</span>
                  <h3 className="text-base font-semibold text-foreground-900 mt-1 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}